import { Box, Grid2 as Grid } from "@mui/material";
import React from "react";
import { ConfigureCover } from "./components/configureCover";
import { CoverPagePreview } from "./components/coverPagePreview";

const CoverPage: React.FC<{ quoteId: string, readOnly: boolean, setIsSaved: any, refetch: any }> = (props) => {
    const [attachments, setAttachments] = React.useState<any>(null);

    return (
        (<Box
            sx={{
                height: "100%",
                overflowY: "hidden"
            }}>
            <Grid
                container
                sx={{
                    height: "calc(100dvh - 120px)",
                    alignItems: "center",
                    overflowY: "hidden"
                }}>
                <Grid
                    sx={{
                        height: "100%",
                        paddingRight: { xs: 0, sm: 1 },
                        pb: "4px",
                        overflowY: "auto"
                    }}
                    size={{
                        xs: 12,
                        sm: 3,
                        md: 4
                    }}>
                    <ConfigureCover {...props} attachments={attachments} setAttachments={setAttachments} />
                </Grid>
                <Grid
                    id="blue"
                    sx={{
                        height: "100%",
                    }}
                    size={{
                        xs: 12,
                        sm: 9,
                        md: 8
                    }}>
                    <CoverPagePreview attachments={attachments} />
                </Grid>
            </Grid>
        </Box>)
    );
};

export default CoverPage;